<template>
  <div>
    <span
      :title="badgeTitle"
      class="badge badge-pill mr-1 c-default" :class="[badgeVariant]" >{{ badgeText }}</span>
  </div>
</template>
<script>
export default {
  name: 'OrderItemTempBadge',
  props: {
    storage_types: {
      type: String,
      required: true,
    },
  },
  computed: {
    badgeTitle() {
      return this.storage_types;
    },
    badgeVariant() {
      if (this.storage_types.match(/fro?ze?(n|d)?/i)) {
        return 'badge-primary';
      } else if (this.storage_types.match(/chi?ll?(e(r|d))?/i)) {
        return 'badge-info';
      } else if (this.storage_types.match(/(ac|dry)/i)) {
        return 'badge-warning';
      }
      return 'badge-light';
    },
    badgeText() {
      if (this.storage_types.match(/fro?ze?(n|d)?/i)) {
        return 'F';
      } else if (this.storage_types.match(/chi?ll?(e(r|d))?/i)) {
        return 'C';
      } else if (this.storage_types.match(/(ac|dry)/i)) {
        return 'D';
      }
      return '';
    },
    types() {
      return this.storage_types
        .split(',')
        .map(t => t.trim());
    },
    badges() {
      return this.types.map(type => ({
        text: type,
        variant: this.defineBadgeVariant(type),
      }));
    },
  },
  methods: {
    defineBadgeVariant(type) {
      const matchDry = type.match(/(AC|DRY|DRIED)/i);
      if (matchDry) return 'badge-warning';

      const matchChill = type.match(/(CHILLER|CHILLED|CHILL|CHL)/i);
      if (matchChill) return 'badge-info';

      const matchFrozen = type.match(/(FROZEN|FROZ|FRZ|FROZED)/i);
      if (matchFrozen) return 'badge-primary';
      return 'badge-light';
    },
  },
};
</script>
<style lang="sass">
.c-default
  cursor: default
</style>


// WEBPACK FOOTER //
// src/components/shipment_md/OrderItemTempBadge.vue